export const GetCalendarStartDay = (day?: string | null): number | undefined => {
  if (!day) return undefined;

  const weekDaysMap: Record<string, number> = {
    sun: 0,
    mon: 1,
    tue: 2,
    wed: 3,
    thu: 4,
    fri: 5,
    sat: 6
  };

  const lowerDay = day.toLowerCase();

  return weekDaysMap[lowerDay] !== undefined ? weekDaysMap[lowerDay] : undefined;
};